<template>
  <div v-if="!fetching">
    <AccountCampaignHeader v-bind="{ title: campaign.name }">
      <FileUpload @file-upload="updateCover">
        <template #button="{ fileUploadButtonClick }">
          <img
            v-if="campaign.cover"
            :srcset="campaign.cover.srcsets || ''"
            @load.once="onImageLoad"
            @click="fileUploadButtonClick"
            sizes="1px"
            :src="campaign.cover.url"
            class="block rounded w-full cursor-pointer"
          />
          <div
            v-else
            @click="fileUploadButtonClick"
            class="aspect-ratio-4/3 w-full rounded bg-gray-900 cursor-pointer"
          />
        </template>
      </FileUpload>
    </AccountCampaignHeader>
    <TabbedMenu />
    <div class="p-16">
      <Transition name="slide-right" mode="out-in">
        <RouterView />
      </Transition>
    </div>
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import { campaignMethods, campaignComputed } from '@/store/helper';
import FileUpload from '@/components/Ui/FileUpload.vue';
import mediableMixin from '@/mixins/mediableMixin';
import AccountCampaignHeader from './single/Header.vue';
import TabbedMenu from './single/TabbedMenu.vue';

export default {
  mixins: [mediableMixin],
  components: {
    AccountCampaignHeader,
    TabbedMenu,
    FileUpload,
  },
  props: {
    campaignId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...campaignComputed,
  },
  beforeRouteEnter: middleware('account-permission:read campaigns'),
  created() {
    const { campaignId } = this;
    this.handleGetCampaign(campaignId);
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...campaignMethods,
    handleGetCampaign(campaignId) {
      this.fetching = true;
      this.getCampaign({ campaignId })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = true;
        });
    },
    updateCover({ config, data, success, error }) {
      const { campaignId } = this;
      this.updateCampaignCover({ config, campaignId, formData: data })
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    },
  },
};
</script>
